import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '../../Framework/Components/Buttons/Button';
import style from '../../../scss/components/buttons/button.module.scss';
import { MessageContext } from '../../Framework/Context/MessageContext';
import Modal from '../../Framework/Components/Modal';

const countryCode = import.meta.env.VITE_COUNTRY_CODE;

const ChangeReviewTypeButton = ({ service, entity }) => {
    const { pushMessage } = useContext(MessageContext);
    const { t } = useTranslation();
    const [actualReviewType, setActualReviewType] = useState(entity.type);
    const [changedReviewType, setChangedReviewType] = useState(entity.type);
    const [marked, setMarked] = useState(false);

    const availableReviewTypes = ['product', 'comment'];
    if (countryCode === 'hu') {
        availableReviewTypes.push('test-it');
    }

    const clearMark = () => setMarked(false);
    const markReviewForChange = () => setMarked(true);

    const getButtonTextForReviewType = (type) => {
        const textMap = {
            'test-it': 'change_review_type_to_test_it',
            product: 'change_review_type_to_product',
            comment: 'change_review_type_to_comment',
        };
        return textMap[type];
    };

    const changeReviewType = () => {
        service
            .post('reviews', 'change-type', {
                reviews: { id: entity.id },
                type: changedReviewType,
            })
            .then(() => {
                pushMessage({
                    title: t('application.change_review_success'),
                });
                setActualReviewType(changedReviewType);
            })
            .catch(() => {
                pushMessage({ title: t('application.change_review_error') });
            })
            .finally(() => {
                clearMark();
            });
    };

    return (
        <>
            <div>
                <p>Review Type</p>
                <p>{actualReviewType}</p>
            </div>
            <div className="radio-buttons mt-4">
                <p>Change Review Type</p>
                {availableReviewTypes.map((review) => (
                    <div key={review} className="radio-option">
                        <input
                            name="reviewType"
                            id={`type-${review}`}
                            type="radio"
                            value={review}
                            checked={changedReviewType === review}
                            disabled={actualReviewType === review}
                            onChange={() => {
                                setChangedReviewType(review);
                            }}
                        />
                        <label htmlFor={`type-${review}`}>
                            {t(`${review}`)}
                        </label>
                    </div>
                ))}
            </div>

            <Button
                classNames={`${style.button} ${style.basic} mt-4`}
                name={getButtonTextForReviewType(changedReviewType)}
                disabled={actualReviewType === changedReviewType}
                onClick={markReviewForChange}
            />

            <Modal
                contentLabel={t(`application.confirm_selection`)}
                isOpen={!!marked}
                onRequestClose={clearMark}
            >
                <p>
                    {t('application.change_review_type_to', {
                        type: t(`application.${changedReviewType}`),
                    })}
                </p>
                <Button
                    name="change_type_confirm_button"
                    click={changeReviewType}
                />
            </Modal>
        </>
    );
};

export default ChangeReviewTypeButton;

ChangeReviewTypeButton.propTypes = {
    /**
     * Type of service
     */
    service: PropTypes.object.isRequired,
    /**
     * Type of entity
     */
    entity: PropTypes.object.isRequired,
};
